import { type ServicesBasePath } from '@repo/api-adapters/services/services.utils';
import { getTimeWindows } from '@repo/api-adapters/services/time-windows.api';
import { type TimeWindowsPayload } from '@repo/types/time-windows';
import { useQuery } from '@tanstack/react-query';

import { API } from './utils.api';

interface UseTimeWindowsParams {
    servicesBasePath: ServicesBasePath;
    payload: TimeWindowsPayload | undefined;
}

export const getTimeWindowsQueryKey = ({
    servicesBasePath,
    payload,
}: {
    servicesBasePath: ServicesBasePath;
    payload: TimeWindowsPayload | undefined;
}) => {
    if (!payload) {
        return [API.timeWindows, servicesBasePath];
    }

    if (payload.delivery && payload.order) {
        return [
            API.timeWindows,
            servicesBasePath,
            payload.order.orderNo,
            payload.delivery.deliveryId,
            payload.delivery.serviceItemId,
            payload.fromDate,
        ];
    }

    if (payload.providedService) {
        return [
            API.timeWindows,
            servicesBasePath,
            payload.providedService.serviceItemNo,
            payload.providedService.serviceProviderId,
            payload.providedService.serviceProductId,
            payload.providedService.transportTimewindows,
            payload.fromDate,
        ];
    }

    return [API.timeWindows, servicesBasePath];
};

export const useTimeWindows = ({ servicesBasePath, payload }: UseTimeWindowsParams) => {
    const queryKey = getTimeWindowsQueryKey({ servicesBasePath, payload });

    return useQuery({
        queryKey,
        enabled: Boolean(payload),
        queryFn: async () => {
            if (!payload) {
                return { timeWindows: [] };
            }
            return getTimeWindows(servicesBasePath, { ...payload });
        },
    });
};
